import React, { useEffect, useRef } from 'react';

export default function FadeIn({ children, delay = 0, className = '', style = {} }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('visible');
          observer.unobserve(el);
        }
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const delayClass = delay ? `delay-${delay}` : '';

  return (
    <div ref={ref} className={`fade-in ${delayClass} ${className}`.trim()} style={style}>
      {children}
    </div>
  );
}
